import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';

export default class BackOfANapkinTemplatesCostFteComponent extends Component {
  @service organisation;

  get ppw() {
    return this.organisation.ppw;
  }

  get horizon() {
    return this.organisation.horizon;
  }

  get valueBeforeConfidence() {
    return this.calculateValue(
      this.args.calculation.ftes,
      this.ppw,
      this.horizon,
    );
  }

  calculateValue(ftes = 0, ppw = 0, horizon = 0) {
    return (+ftes || 0) * ppw * horizon * 4;
  }

  @action
  onConfidenceChange(confidence) {
    const calculation = { ...this.args.calculation };
    calculation.confidence_value = confidence.value;
    calculation.confidence_label = confidence.label;
    this.args.onValueEmit(calculation);
  }

  @action
  handleChange(e) {
    const calculation = { ...this.args.calculation };
    calculation[e.target.name] = Number(e.target.value);
    calculation.value = this.calculateValue(
      calculation.ftes,
      this.ppw,
      this.horizon,
    );
    calculation.price_person_week = this.ppw;
    calculation.horizon = this.horizon;
    this.args.onValueEmit(calculation);
  }

  @action
  onRender() {
    this.updateValue();
  }

  updateValue() {
    const finalValue = this.finalValue;
    if (isNaN(finalValue)) return;
    const calculation = { ...this.args.calculation };
    calculation.value = this.valueBeforeConfidence;
    this.args.onValueEmit(calculation);
  }

  get confidenceLabel() {
    // if (this.args.calculation.confidence === undefined) return '-';
    // else if (this.args.type === 'Investment')
    //   return this.organisation.getInvestmentConfidenceLabel(this.args.calculation.confidence);
    // else if (this.args.type === 'Return')
    //   return this.organisation.getReturnConfidenceLabel(this.args.calculation.confidence);
    // return 'Not selected';
    return this.args.calculation.confidence_label ?? '-';
  }

  get finalValue() {
    if (
      !isNullOrUndefined(this.args.calculation.ftes) &&
      !isNullOrUndefined(this.ppw) &&
      !isNullOrUndefined(this.horizon) &&
      !isNullOrUndefined(this.args.calculation.confidence_value)
    )
      return (
        this.valueBeforeConfidence * +this.args.calculation.confidence_value
      );
    else return '-';
  }

  get isDisabled() {
    return !this.args.editMode;
  }
}
